import { IResponse } from '../types';
import axiosInstance from '../axiosInstance';
import { requestResources } from '../requestResources';
import { IPortalConfig, ITechnicianData } from './types';

const { clientPortalConfig } = requestResources;

export const getClientPortalConfiguration = (): IResponse<IPortalConfig> =>
  axiosInstance.get(`${clientPortalConfig}`);

export const getClientPortalTechnicianData = (): IResponse<ITechnicianData> =>
  axiosInstance.get(`${clientPortalConfig}/techOptions`);
